"use client";

type Props = {
  expanded: boolean;
  onClick: () => void;
};
const DetailsToggleButton = ({
  expanded,
  onClick
}: Props) => {
  return <button type='button' onClick={onClick} className='flex shrink-0 items-center justify-end gap-[5px] rounded-[31px] border border-Gray-400 bg-white/80 px-3 py-2 text-[12px] font-medium leading-none text-Gray-700' data-sentry-component="DetailsToggleButton" data-sentry-source-file="DetailsToggleButton.tsx">
      {expanded ? "Hide details" : "See details"}
    </button>;
};
export default DetailsToggleButton;